import React from 'react';

import { List, FilterForm, Datagrid } from 'components/list';
import { TextInput } from 'components/input';
import { TextField } from 'components/field';
import { EditButton } from 'components/button';

import {
  shopLoginWhitelistEditFrontendPath,
} from './urls'

const StatusField = (props) => {
    const { source, record } = props;
    const newRecord = {};
    if(record[source]){
      newRecord[source] = 'Enabled';
    }
    else {
      newRecord[source] = 'Disabled';
    }

    return (
      <TextField {...props} record={newRecord}/>
    );
  }
;

export const ShopLoginWhitelistFilter = (props) => (
  <FilterForm name="shop_list_filter" {...props}>
    <TextInput label="Mobile" source="mobile_number"/>
    <TextInput label="Shop ID" source="shop_id"/>
  </FilterForm>
);

export const ShopLoginWhitelist = (props) => (
  <List {...props} filters={<ShopLoginWhitelistFilter />}>
    <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
      <TextField source="id" label="ID"/>
      <TextField source="shop_id" label="Shop ID"/>
      <TextField source="owner_mobile" label="Owner Mobile"/>
      <TextField source="reason" label="Reason"/>
      <TextField source="expiry_time" label="Expiry Time"/>
      <TextField source="created_by" label="Created By"/>
      <TextField source="last_updated_by" label="Last Updated By"/>
      <StatusField source="status" label="Status"/>
      <EditButton linkTo={shopLoginWhitelistEditFrontendPath} label="Edit"/>
    </Datagrid>
  </List>
);


// WEBPACK FOOTER //
// ./src/routes/shop/ShopLoginWhitelist.js